'use strict';

var processInclude = require('base/util');

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('gtm/gtm'));
    processInclude(require('./gtm/gtm'));
});
